import React, { useEffect, useState } from 'react';
import css from './ContactInfoStep.module.css';
import { WizardStepWrapper } from '../step';
import {
  H2,
  H3,
  IndicatesRequired,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../../core';
import {
  ContactDetails,
  ContactInfoDetails,
  Demographics,
  EmptyContactDetails,
  SchedulingDetails,
} from '../../../../api/models';
import { AreDemographicsValid } from '../../../demographicsInput';
import { PatientDemographics } from './patientDemographics';
import {
  ContactInformation,
  IsContactInformationValid,
} from './contactInformation';

export interface ContactInfoStepPresenterProps {
  schedulingDetails: SchedulingDetails;
  onPatientDemographicsChanged: (demographics: Demographics) => void;
  onContinue: (contactInfoDetails: ContactInfoDetails) => void;
}

const ContactInfoStepPresenter: React.FC<ContactInfoStepPresenterProps> = (
  props: ContactInfoStepPresenterProps
) => {
  const [patientContactDetails, setPatientContactDetails] =
    useState<ContactDetails>(EmptyContactDetails);
  const [validate, setValidate] = useState<boolean>(false);

  useEffect(() => {
    setPatientContactDetails(
      props.schedulingDetails.contactInfoDetails?.patientContactDetails ??
        EmptyContactDetails
    );
  }, [props.schedulingDetails.contactInfoDetails]);

  const onContinue = () => {
    if (isValid()) {
      props.onContinue({
        patientContactDetails: patientContactDetails,
      });
    } else {
      setValidate(true);
    }
  };

  // return false to cancel onContinue
  const isValid = (): boolean => {
    return (
      props.schedulingDetails?.patientDetails !== undefined &&
      props.schedulingDetails.patientDetails.demographics !== undefined &&
      AreDemographicsValid(
        props.schedulingDetails.patientDetails.demographics
      ) &&
      IsContactInformationValid(patientContactDetails) &&
      true
    );
  };

  const onPatientContactInfoChanged = (contactDetails: ContactDetails) => {
    setPatientContactDetails(contactDetails);
  };

  return (
    <WizardStepWrapper onContinue={onContinue} stickyWhenNarrow={false}>
      <StackedColumn fillHeight={true} spacing={StackedColumnSpacing.Wider}>
        <StackedColumn spacing={StackedColumnSpacing.Wide}>
          <StackedColumn>
            <H2 text="Please fill out additional information about the patient." />
            <IndicatesRequired />
          </StackedColumn>
          <PatientDemographics
            patientDetails={props.schedulingDetails.patientDetails}
            validate={validate}
            onDemographicsChanged={props.onPatientDemographicsChanged}
          />
        </StackedColumn>
        <div className={css.container}>
          <StackedColumn>
            <H3 text="Patient's contact information" />
            <ContactInformation
              contactDetails={patientContactDetails}
              validate={validate}
              onContactInfoChanged={onPatientContactInfoChanged}
            />
          </StackedColumn>
        </div>
      </StackedColumn>
    </WizardStepWrapper>
  );
};

export default ContactInfoStepPresenter;
